import { useCallback } from 'react'

const useAntifraudSDK = () => {
  const initAntifraudSession = useCallback(
    async (orderID: string, methodID: string): Promise<string | null> => {
      try {
        const sdk = (window as any)?.AnalyticsSDK?.createAnalyticsSdk({
          apiBaseUrl: process.env.NEXT_PUBLIC_AF_API_BASE_URL,
          apiKey: process.env.NEXT_PUBLIC_AF_API_KEY,
          orderID,
          pspID: process.env.NEXT_PUBLIC_AF_PSP_ID,
          methodID,
          getSessionTimeoutMs: 700,
        })
        const result = await sdk?.init()
        return result?.sessionID
      } catch (e) {
        console.error('AF SDK init failed: ', e)
        return null
      }
    },
    [],
  )

  return { initAntifraudSession }
}

export default useAntifraudSDK
